module.exports = __webpack_public_path__ + "img/trial_popup.0023ca80.png";